<template>
  <div>
    <header-block title="Buy with Confidence" ></header-block>
      <div class="textContainer">
        <h2 class="title">How it works</h2>

        <p class="paragraph">
          Enter the value of the voucher you would like to purchase
        </p>

        <div class="circle">1</div>

        <p class="paragraph">
          Make payment
        </p>

        <div class="circle">2</div>

        <p class="paragraph">
          Your voucher will be added to your account
        </p>

        <div class="circle">3</div>

        <p class="paragraph">
          Some retail cards need to be "claimed" before they can be used.  Follow the on screen instructions
        </p>
        
      </div>
      <div class="footerText anchor-bottom">
        <p>We never share any information with your employer, or a third party without your consent.</p>
      </div>
    </div>
</template>

<script>
import HeaderBlock from './elements/HeaderBlock.vue';

export default {
  name: 'BuyWithConfidencePage',
  components: {
    HeaderBlock
  }
};
</script>

<style scoped>

.paragraph {
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 16px;
}
.imageContainer {
    /* margin: -20px -30px 0px -30px; */
    margin-left: -30px;
    margin-right: -30px;
    background-size: cover;
    margin-top: -20px;
    /* padding-top: 155px; */
}

.textContainer {
  padding: 40px 20px;
  margin-left: -30px;
  margin-right: -30px;
  text-align: center;
}

.paymentMethods {
  position: relative;
  width: 200px;
  margin: 20px auto 0 auto;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.footerText {
  padding: 40px 20px;
  text-align: center;
}

.footerText p {
  font-size: 11px;
}

.circle {
  background-color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: bold;
}
</style>
